"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var date_1 = require("../utils/date");

var object_1 = require("../utils/object");

var typeChecks_1 = require("../utils/typeChecks");

var isArrayLike_1 = require("../utils/isArrayLike");

var Query_1 = require("../query/Query");

var formatter_1 = require("../utils/formatter");
/**
 * The ConditionalHelper allows for a generic conditional object to be used to determine if certain conditions are met.
 */


var ConditionalHelper =
/** @class */
function () {
  function ConditionalHelper(conditional, translationHelper) {
    this.conditional = conditional;
    this.translationHelper = translationHelper;
  }

  ConditionalHelper.prototype.matchesWithOptions = function (options) {
    var response = false;

    var _a = options.conditional,
        conditional = _a === void 0 ? this.conditional : _a,
        validateConditionOptions = __rest(options, ["conditional"]);

    var conditions = conditional.conditions,
        format = conditional.format;
    var conditionValues = [];

    if (conditions) {
      for (var _i = 0, conditions_1 = conditions; _i < conditions_1.length; _i++) {
        var condition = conditions_1[_i];
        var conditionValue = this.validateConditionWithOptions(condition, validateConditionOptions);
        conditionValues.push(conditionValue);
      }
    }

    response = this.applyConditionFormat(conditionValues, conditions, format);
    return response;
  };

  ConditionalHelper.prototype.matches = function (instance, conditional, executionOptions) {
    return this.matchesWithOptions({
      instance: instance,
      conditional: conditional,
      executionOptions: executionOptions
    });
  };

  ConditionalHelper.prototype.validateConditionFormat = function (format, keys) {
    var validCharacters = ['(', ')', '&', '|', ' ', '{', '}', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9']; // Strip out the valid keys

    for (var _i = 0, _a = keys || []; _i < _a.length; _i++) {
      var key = _a[_i];
      format = format.split("{" + key + "}").join('');
    }

    var conditionalFormatChars = format.split('');
    var isValid = true;

    for (var _b = 0, conditionalFormatChars_1 = conditionalFormatChars; _b < conditionalFormatChars_1.length; _b++) {
      var char = conditionalFormatChars_1[_b];
      isValid = isValid && validCharacters.indexOf(char) > -1;

      if (!isValid) {
        break;
      }
    }

    return isValid;
  };

  ConditionalHelper.prototype.orchestrateConditionFormat = function (conditionResults, format) {
    if (!format || format === '') {
      format = '';

      for (var i = 1; i <= conditionResults.length; i++) {
        if (i > 1) {
          format += ' && ';
        }

        format += "{" + i + "}";
      }
    }

    format = format.toLowerCase();
    format = format.split('and').join('&&');
    format = format.split('or').join('||');
    var singleCharChecks = ['&', '|'];
    var chars = format.split('');

    for (var i = 0; i < chars.length; i++) {
      var currentChar = chars[i];

      for (var _i = 0, singleCharChecks_1 = singleCharChecks; _i < singleCharChecks_1.length; _i++) {
        var singleChar = singleCharChecks_1[_i];

        if (currentChar === singleChar) {
          if (i === 0) {
            chars.shift();
            i--;
          } else if (i === chars.length - 1) {
            chars.pop();
          } else {
            var previousChar = chars[i - 1];
            var nextChar = chars[i + 1];

            if (previousChar !== singleChar && nextChar !== singleChar) {
              chars.splice(i, 0, singleChar);
            }
          }
        }
      }
    }

    while (singleCharChecks.includes(chars[chars.length - 1])) {
      chars.pop();
    }

    format = chars.join('').trim();
    return format;
  };

  ConditionalHelper.prototype.applyConditionFormat = function (conditionResults, conditions, format) {
    if (!conditionResults || conditionResults.length === 0) {
      return true;
    }

    var workingFormat = this.orchestrateConditionFormat(conditionResults, format);
    var conditionKeys = conditions.filter(function (condition) {
      return !!condition.key;
    }).map(function (condition) {
      return condition.key;
    }); // Check only valid characters used with place holders in workingFormat ({0}, {1} etc.)

    var isValid = this.validateConditionFormat(workingFormat, conditionKeys);

    if (isValid) {
      var indexOffset = workingFormat.indexOf('{0}') > -1 ? 0 : 1;

      for (var i = 0; i < conditionResults.length; i++) {
        // Force the value into a boolean, so as to not let any unwanted values creeping through
        var resultString = (!!conditionResults[i]).toString();
        workingFormat = workingFormat.split("{" + (i + indexOffset) + "}").join(resultString);
        var condition = conditions && conditions.length > i && conditions[i];

        if (condition) {
          var key = condition.key;

          if (key) {
            workingFormat = workingFormat.split("{" + key + "}").join(resultString);
          }
        }
      } // Check no extra place holders in place


      var placeholderBraces = ['{', '}'];

      for (var _i = 0, placeholderBraces_1 = placeholderBraces; _i < placeholderBraces_1.length; _i++) {
        var char = placeholderBraces_1[_i];
        isValid = isValid && workingFormat.indexOf(char) === -1;

        if (!isValid) {
          break;
        }
      }

      if (isValid) {
        try {
          // tslint:disable-next-line:no-eval
          isValid = eval(workingFormat);
        } catch (ex) {
          isValid = false;
        }
      } else {
        console.error("invalid condition format without place holders: " + workingFormat);
      }
    } else {
      console.error("invalid condition format with place holders: " + workingFormat);
    }

    return isValid;
  };

  ConditionalHelper.prototype.arrayContains = function (collection, search, isCaseSensitive) {
    if (isCaseSensitive === void 0) {
      isCaseSensitive = false;
    }

    if (!typeChecks_1.isNullOrUndefined(collection) && !typeChecks_1.isNullOrUndefined(search)) {
      return undefined !== collection.find(function (item) {
        var valueString = item.toString();
        var searchString = search.toString();

        if (!isCaseSensitive) {
          valueString = valueString.toLowerCase();
          searchString = searchString.toLowerCase();
        }

        return valueString === searchString;
      });
    }

    return false;
  };

  ConditionalHelper.prototype.contains = function (value, search, isCaseSensitive) {
    if (isCaseSensitive === void 0) {
      isCaseSensitive = false;
    }

    if (!typeChecks_1.isNullOrUndefined(value) && !typeChecks_1.isNullOrUndefined(search)) {
      var valueString = value.toString();
      var searchString = search.toString();

      if (!isCaseSensitive) {
        valueString = valueString.toLowerCase();
        searchString = searchString.toLowerCase();
      }

      return valueString.indexOf(searchString) > -1;
    }

    return false;
  };

  ConditionalHelper.prototype.startsWith = function (value, search, isCaseSensitive) {
    if (isCaseSensitive === void 0) {
      isCaseSensitive = false;
    }

    if (!typeChecks_1.isNullOrUndefined(value) && !typeChecks_1.isNullOrUndefined(search)) {
      if (!Array.isArray(search)) {
        search = [search];
      }

      return !!search.find(function (s) {
        var valueString = value.toString();
        var searchString = s.toString();

        if (!isCaseSensitive) {
          valueString = valueString.toLowerCase();
          searchString = searchString.toLowerCase();
        }

        return valueString.indexOf(searchString) === 0;
      });
    }

    return false;
  };

  ConditionalHelper.prototype.endsWith = function (value, search, isCaseSensitive) {
    if (isCaseSensitive === void 0) {
      isCaseSensitive = false;
    }

    if (!typeChecks_1.isNullOrUndefined(value) && !typeChecks_1.isNullOrUndefined(search)) {
      if (!Array.isArray(search)) {
        search = [search];
      }

      return !!search.find(function (s) {
        var valueString = value.toString();
        var searchString = s.toString();

        if (!isCaseSensitive) {
          valueString = valueString.toLowerCase();
          searchString = searchString.toLowerCase();
        }

        return valueString.indexOf(searchString) === valueString.length - searchString.length;
      });
    }

    return false;
  };

  ConditionalHelper.prototype.validateConditionWithOptions = function (condition, options) {
    var _this = this;

    if (!condition || typeof condition !== 'object') {
      return false;
    }

    var field = condition.field,
        fieldQuery = condition.fieldQuery,
        fieldDateDifference = condition.fieldDateDifference,
        operator = condition.operator,
        isCaseSensitive = condition.isCaseSensitive,
        regexTestFlags = condition.regexTestFlags,
        fieldFormat = condition.fieldFormat,
        valueFormat = condition.valueFormat;
    var workingOperator = operator ? operator.toLowerCase() : '=';
    var response = false;
    var value;

    if (!typeChecks_1.isUndefined(condition.value)) {
      value = condition.value;
    } else if (!typeChecks_1.isUndefined(condition.valueQuery) && options.executionOptions) {
      value = this.getQueryResponse(condition.valueQuery, options.executionOptions);
    }

    if (!typeChecks_1.isUndefined(valueFormat)) {
      value = formatter_1.formatter(valueFormat, value);
    }

    var translatedValue;

    if (this.translationHelper && ['!=', '=', 'includes', 'excludes', 'in', 'not-in'].indexOf(workingOperator) >= 0) {
      if (Array.isArray(value)) {
        translatedValue = value.map(function (item) {
          return _this.translationHelper.translate(item);
        });
      } else {
        translatedValue = this.translationHelper.translate(value);
      }
    }

    var fieldValue = options.instance;

    if (field && options.instance) {
      fieldValue = object_1.getValueFromStringNotation(field, options.instance);
    } else if (fieldQuery && options.executionOptions) {
      fieldValue = this.getQueryResponse(fieldQuery, options.executionOptions);
    } else if (fieldDateDifference) {
      var period = fieldDateDifference.period,
          start = fieldDateDifference.start,
          end = fieldDateDifference.end,
          useNowForEndDate = fieldDateDifference.useNowForEndDate;

      if (period && start && (end || useNowForEndDate)) {
        var startDateRaw = this.getQueryResponse(fieldDateDifference.start, options.executionOptions);
        var endDateRaw = void 0;

        if (fieldDateDifference.useNowForEndDate) {
          endDateRaw = new Date().toUTCString();
        } else {
          endDateRaw = this.getQueryResponse(fieldDateDifference.end, options.executionOptions);
        }

        fieldValue = date_1.getDateDifference(endDateRaw, startDateRaw, fieldDateDifference.period);
      }
    }

    if (!typeChecks_1.isUndefined(fieldFormat)) {
      fieldValue = formatter_1.formatter(fieldFormat, fieldValue);
    }

    var valueIsDate = this.isDate(value);
    var fieldValueIsDate = this.isDate(fieldValue);

    switch (workingOperator) {
      case '!=':
        response = fieldValue !== value && (translatedValue === undefined || fieldValue !== translatedValue);
        break;

      case '=':
        response = fieldValue === value || translatedValue !== undefined && fieldValue === translatedValue;
        break;

      case '>':
        if (!valueIsDate || !fieldValueIsDate) {
          response = parseFloat(fieldValue) > parseFloat(value);
        } else {
          response = fieldValue > value;
        }

        break;

      case '>=':
        if (!valueIsDate || !fieldValueIsDate) {
          response = parseFloat(fieldValue) >= parseFloat(value);
        } else {
          response = fieldValue >= value;
        }

        break;

      case '<':
        if (!valueIsDate || !fieldValueIsDate) {
          response = parseFloat(fieldValue) < parseFloat(value);
        } else {
          response = fieldValue < value;
        }

        break;

      case '<=':
        if (!valueIsDate || !fieldValueIsDate) {
          response = parseFloat(fieldValue) <= parseFloat(value);
        } else {
          response = fieldValue <= value;
        }

        break;

      case 'includes':
        if (Array.isArray(fieldValue)) {
          response = this.arrayContains(fieldValue, value, isCaseSensitive) || translatedValue !== undefined && this.arrayContains(fieldValue, translatedValue, isCaseSensitive);
        } else {
          response = this.contains(fieldValue, value, isCaseSensitive) || translatedValue !== undefined && this.contains(fieldValue, translatedValue, isCaseSensitive);
        }

        break;

      case 'excludes':
        if (Array.isArray(fieldValue)) {
          response = !this.arrayContains(fieldValue, value, isCaseSensitive) && (translatedValue === undefined || !this.arrayContains(fieldValue, translatedValue, isCaseSensitive));
        } else {
          response = !this.contains(fieldValue, value, isCaseSensitive) && (translatedValue === undefined || !this.contains(fieldValue, translatedValue, isCaseSensitive));
        }

        break;

      case 'in':
        if (isArrayLike_1.isArrayLike(value)) {
          response = this.arrayContains(value, fieldValue, isCaseSensitive) || this.arrayContains(translatedValue, fieldValue, isCaseSensitive);
        }

        break;

      case 'not-in':
        if (isArrayLike_1.isArrayLike(value)) {
          response = !this.arrayContains(value, fieldValue, isCaseSensitive) && !this.arrayContains(translatedValue, fieldValue, isCaseSensitive);
        }

        break;

      case 'defined':
        response = !typeChecks_1.isUndefined(fieldValue);
        break;

      case 'undefined':
        response = typeChecks_1.isUndefined(fieldValue);
        break;

      case 'not-null':
        response = fieldValue !== null;
        break;

      case 'null':
        response = fieldValue === null;
        break;

      case 'starts-with':
        response = this.startsWith(fieldValue, value, isCaseSensitive) || this.startsWith(fieldValue, translatedValue, isCaseSensitive);
        break;

      case 'ends-with':
        response = this.endsWith(fieldValue, value, isCaseSensitive) || this.endsWith(fieldValue, translatedValue, isCaseSensitive);
        break;

      case 'not-starts-with':
        response = !this.startsWith(fieldValue, value, isCaseSensitive) && !this.startsWith(fieldValue, translatedValue, isCaseSensitive);
        break;

      case 'not-ends-with':
        response = !this.endsWith(fieldValue, value, isCaseSensitive) && !this.endsWith(fieldValue, translatedValue, isCaseSensitive);
        break;

      case 'null-or-empty':
        response = typeChecks_1.isNullOrEmpty(fieldValue);
        break;

      case 'not-null-or-empty':
        response = !typeChecks_1.isNullOrEmpty(fieldValue);
        break;

      case 'regex-test':
        var regex = new RegExp(value, regexTestFlags);
        response = regex.test(fieldValue);
        break;

      default:
        response = false;
        break;
    }

    return response;
  };

  ConditionalHelper.prototype.isDate = function (value) {
    return typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}/);
  };

  ConditionalHelper.prototype.validateCondition = function (condition, instance) {
    return this.validateConditionWithOptions(condition, {
      instance: instance
    });
  };

  ConditionalHelper.prototype.getQueryResponse = function (options, executionOptions) {
    var query = new Query_1.Query(options);
    return query.execute(executionOptions);
  };

  return ConditionalHelper;
}();

exports.ConditionalHelper = ConditionalHelper;